//
// Module for the Security Administration Users associations search view.
//
rs.module("ui/content/security/administration/users/associations/search",

    [
        "common/visibility",
        "controls/components/event-banner",
        "controls/data/grid"
    ],

    function (visibility, eventBanner, gridModule) {

        // Visibility booleans that determine the modal search's display.
        var _isEDSearchModalOpen;
        var _isParticipantSearchModalOpen;

        // Js object to store keys related to posting multiple employer associations.
        var _employerAssociations;

        // Initialize the module
        function initialize(
            jsSelectors, 
            columnIds, 
            backendUrls, 
            propertyAliases,
            employerSearchGridLrsApi, 
            participantSearchGridLrsApi,
            esfUserId) {

            // Perform onLoad operations.
            _employerAssociations = [];

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);
            var addEmployerDirectAssociationBtn = criteria.js(jsSelectors.addEmployerDirectAssociationBtn, { required: false });
            var addUserRecordSecurityAssociationBtn = criteria.js(jsSelectors.addUserRecordSecurityAssociationBtn);

            var search = $.js(jsSelectors.search);
            var searchHeaderText = search.js(jsSelectors.searchHeaderText);
            var searchCancelButton = search.js(jsSelectors.searchCancelButton);
            var modalPopupAddButton = search.js(jsSelectors.modalPopupAddButton);

            var employerSearchContainer = search.js(jsSelectors.employerSearchContainer);
            var employerSearchInput = search.js(jsSelectors.employerSearchInput);
            var employerSearchButton = search.js(jsSelectors.employerSearchButton);
            var employerSearchGridContainer = search.js(jsSelectors.employerSearchGridContainer);

            var participantSearchContainer = search.js(jsSelectors.participantSearchContainer);
            var participantSearchInput = search.js(jsSelectors.participantSearchInput);
            var participantSearchButton = search.js(jsSelectors.participantSearchButton);
            var participantSearchGridContainer = search.js(jsSelectors.participantSearchGridContainer);
            var selectedPersonKey = search.js(jsSelectors.selectedPersonKey);

            // Setup button click events
            if (addEmployerDirectAssociationBtn) {
                addEmployerDirectAssociationBtn.click(function () { openSearchModal(true, false); });
            }
            addUserRecordSecurityAssociationBtn.click(function () { openSearchModal(false, true); });
            searchCancelButton.click(function () { closeSearchModal(); });
            modalPopupAddButton.click(function () { postSearchModal(); });

            // Setup events that trigger a search.
            employerSearchInput.on("keydown", onEnterInput);
            participantSearchInput.on("keydown", onEnterInput);
            employerSearchButton.on("click", initiateSearch);
            participantSearchButton.on("click", initiateSearch);

            // Setup the employer direct association search grid selection change event.
            employerSearchGridLrsApi.selectionChanged(function (values, rows) {

                // need to make sure values is greater than zero because grid.selectionChanged fires when grid is first rendered
                if (values.length > 0) {
                    
                    // clear banner.
                    eventBanner.removeAllMessages();

                    // Build new list of selected employer associations.
                    _employerAssociations = buildEmployerAssociations(rows);

                    // Enable add button if one is selected.
                    modalPopupAddButton.prop('disabled', false);
                }
                else {
                    modalPopupAddButton.prop('disabled', true);
                }
            });

            // Setup the user record security association search grid selection change event.
            participantSearchGridLrsApi.selectionChanged(function (values, rows) {

                // need to make sure values is greater than zero because grid.selectionChanged fires when grid is first rendered
                if (values.length > 0) {

                    eventBanner.removeAllMessages();

                    // Select hidden keys
                    selectedPersonKey.val(rows[0][columnIds.personKey]);
                    modalPopupAddButton.prop('disabled', false);
                }
                else {
                    modalPopupAddButton.prop('disabled', true);
                }
            });

            // Open the search modal according to provided rules.
            function openSearchModal(forEDAssociation, forUSRAssociation) {

                // Change modal header
                if (forEDAssociation) {
                    searchHeaderText.text("Search Employers");
                    _isEDSearchModalOpen = true;
                    _isParticipantSearchModalOpen = false;
                }
                else if (forUSRAssociation) {
                    searchHeaderText.text("Search Participants");
                    _isEDSearchModalOpen = false;
                    _isParticipantSearchModalOpen = true;
                    participantSearchInput.focus();
                }
                else {
                    _isEDSearchModalOpen = false;
                    _isParticipantSearchModalOpen = false;
                }

                // Display correct modal body
                visibility.setVisible(employerSearchContainer, forEDAssociation);
                visibility.setVisible(employerSearchGridContainer, false);
                visibility.setVisible(participantSearchContainer, forUSRAssociation);
                visibility.setVisible(participantSearchGridContainer, false);

                // Show modal
                search.modal("show");
            }

            // Focus search input field when modal is shown.
            search.on('shown.bs.modal', function () {
                // Focus employer direct association search input.
                if (_isEDSearchModalOpen) {
                    employerSearchInput.focus();
                }

                // Focus participant/USR association search input.
                if (_isParticipantSearchModalOpen) {
                    participantSearchInput.focus();
                }
            });

            // Post the association modal
            function postSearchModal() {

                if (_isParticipantSearchModalOpen && selectedPersonKey.val() != '') {

                    // Post account for User Record Security association
                    $.post(
                        backendUrls.postUserAssociation,
                        {
                            participantKey: selectedPersonKey.val(),
                            esfUserId: esfUserId
                        })
                        .done(function () {

                            // We do not use window.location.reload() because that could POST if the current page was loaded via a POST.  
                            // We want a GET, so will set the window location to the current page, with filter.
                            window.location = backendUrls.redirectionUrl;
                        })
                        .fail(function (xhr, _, error) {

                            console.log(error || xhr.responseJSON || "A error occurred while processing the delete.");

                        });
                }
                else if (_isEDSearchModalOpen && _employerAssociations.length > 0) {

                    // Post account for User Record Security association
                    $.post(
                        backendUrls.postEmployerAssociations,
                        {
                            associations: _employerAssociations,
                            esfUserId: esfUserId
                        })
                        .done(function () {

                            // We do not use window.location.reload() because that could POST if the current page was loaded via a POST.
                            // We want a GET, so will set the window location to the current page, with filter.
                            window.location = backendUrls.redirectionUrl;
                        })
                        .fail(function (xhr, _, error) {

                            console.log(error || xhr.responseJSON || "A error occurred while processing the delete.");
                        });
                }

                // We want to submit the page on Modal Add button clicks.
                closeSearchModal();
                return true;
            }

            // Handle closing the modal
            function closeSearchModal() {

                // Hide modal
                search.modal('hide');

                return false;
            }

            // Handle modal hide event
            search.on('hide.bs.modal', function (e) {

                // Reset modal booleans
                _isEDSearchModalOpen = false;
                _isParticipantSearchModalOpen = false;

                // Clear container values
                _employerAssociations = [];
                selectedPersonKey.val('');
                employerSearchInput.val('');
                participantSearchInput.val('');
                employerSearchGridLrsApi.selectedValues = '';
                participantSearchGridLrsApi.selectedValues = '';

                // Hide containers
                visibility.setVisible(employerSearchContainer, false);
                visibility.setVisible(participantSearchContainer, false);
                visibility.setVisible(employerSearchGridContainer, false);
                visibility.setVisible(participantSearchGridContainer, false);
            });

            // Trigger search when pressing Enter inside search input.
            function onEnterInput(event) {
                if (event.which == 13) {
                    initiateSearch();

                    // by default forms will submit when Enter is pressed, this suppresses that behavior
                    return false;
                }
            }

            // Initiate the search
            function initiateSearch() {

                // Find which query has been filled.
                if (_isParticipantSearchModalOpen) {
                    var query = participantSearchInput.val().trim();

                    gridModule.update(
                        backendUrls.searchUserRecordAssociations,
                        {
                            query: query
                        },
                        participantSearchGridLrsApi.agGridApi,
                        function done() {
                            participantSearchGridLrsApi.selectFirstRow();
                            visibility.setVisible(participantSearchGridContainer, true);
                        }
                    );
                }
                else if (_isEDSearchModalOpen) {
                    var query = employerSearchInput.val().trim();

                    gridModule.update(
                        backendUrls.searchEmployerDirectAssociations,
                        {
                            query: query
                        },
                        employerSearchGridLrsApi.agGridApi,
                        function done() {
                            visibility.setVisible(employerSearchGridContainer, true);
                        }
                    );
                }
            }

            // Build employer associations from the selected employer grid rows.
            function buildEmployerAssociations(gridRows) {

                var associations = [];
                for (var index in gridRows) {

                    // Unpack employer and fund keys.
                    var employerkey = gridRows[index][columnIds.employerKey];
                    var fundKey = gridRows[index][columnIds.fundKey];

                    // build an association object.
                    var association = {};
                    association[propertyAliases.employerAssociation_employerKey] = employerkey,
                    association[propertyAliases.employerAssociation_fundKey] = fundKey

                    // add the association object to the list.
                    associations.push(association);
                }

                return associations;
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);